import script from "./ClientPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientPage.vue?vue&type=script&setup=true&lang=js"

import "./ClientPage.vue?vue&type=style&index=0&id=56571f3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56571f3c"]])

export default __exports__